import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  arrayComponent: any;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'default',
        titulo: 'Carousel simple',
        subtitulo: 'Carousel básico',
        claseContainer: 'col-12',
        componentRender:
          `<div id="demo" class="carousel slide" data-ride="carousel">
    <!-- Indicators -->
    <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <li data-target="#demo" data-slide-to="2"></li>
    </ul>

    <!-- The slideshow -->
    <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="https://www.gov.co/home/portada-01-abril.7755328688b5440943ed.jpg" alt="Colombia" class="d-block w-100" >
        </div>
        <div class="carousel-item">
          <img src="https://www.gov.co/home/portada-01-abril.7755328688b5440943ed.jpg" alt="Colombia" class="d-block w-100" >
        </div>
        <div class="carousel-item">
          <img src="https://www.gov.co/home/portada-01-abril.7755328688b5440943ed.jpg" alt="Colombia" class="d-block w-100" >
        </div>
    </div>

    <!-- Left and right controls -->
    <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="govco-icon govco-icon-shortl-arrow "></span>

    </a>
    <a class="carousel-control-next" href="#demo" data-slide="next">
        <span class="govco-icon govco-icon-shortr-arrow "></span>
    </a>
</div>
      `,

      },
    ]
    this.infoComponent = {
      titulo: "Carousel",
      descripcion: ""
    }

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    window.utils.init();
  }

}